import { useTimeAgo, UseTimeAgoMessages, UseTimeAgoUnitNamesDefault } from '@vueuse/core'
import { MaybeRef } from 'vue'
import { $tc, $t } from '@/app-bootstrapping/SetUpInternationalization'

type DateLike = Date | string | number

// Shamelessly stolen from https://github.com/vueuse/vueuse/issues/1592 and improved
// A simple localized version of vueuse's useTimeAgo
export function useLocaleTimeAgo(date: MaybeRef<DateLike>) {
  const I18N_MESSAGES: UseTimeAgoMessages<UseTimeAgoUnitNamesDefault> = {
    justNow: $t('just now'),
    past: (n) => (n.match(/\d/) ? $t(':timeString', { timeString: n }) : n),
    future: (n) => (n.match(/\d/) ? $t('in :timeString', { timeString: n }) : n),
    month: (n, past) =>
      n === 1
        ? past
          ? $t('last month')
          : $t('next month')
        : $tc(`:time month | :time months`, n, { time: n }),
    year: (n, past) =>
      n === 1
        ? past
          ? $t('last year')
          : $t('next year')
        : $tc(`:time year | :time years`, n, { time: n }),
    day: (n, past) =>
      n === 1
        ? past
          ? $t('yesterday')
          : $t('tomorrow')
        : $tc(`:time day | :time days`, n, { time: n }),
    week: (n, past) =>
      n === 1
        ? past
          ? $t('last week')
          : $t('next week')
        : $tc(`:time week | :time weeks`, n, { time: n }),
    hour: (n) => $tc(':time hour | :time hours', n, { time: n }),
    minute: (n) => $tc(':time minute | :time minutes', n, { time: n }),
    second: (n) => $tc(`:time second | :time seconds`, n, { time: n }),
    invalid: '',
  }

  return useTimeAgo(date, {
    fullDateFormatter: (d: Date) => d.toLocaleDateString(),
    messages: I18N_MESSAGES,
  })
}
